module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic.a9887460.svg";